import { useContext, useEffect, useState } from "react";
import React, { Fragment } from "react";
import { UserContext } from "../../context/userContext";
import { useNavigate } from "react-router-dom";
import { Table } from "react-bootstrap";
import {Row,Col,Form,Input,Label,Button,CardText,CardTitle,FormFeedback,UncontrolledTooltip} from 'reactstrap'
import { useMediaQuery } from 'react-responsive'
import { API, setAuthToken } from "../../config/api";
import {FaUser,FaUserMd, FaGenderless, FaMailBulk, FaTransgender, FaPhone, FaAddressBook, FaAddressCard, FaEdit, FaTrash, FaSave, FaPlus, FaSearch, FaUserAlt, FaAccessibleIcon, FaCriticalRole, FaUserClock, FaUserCheck, FaAccusoft, FaArchive, FaBackspace, FaBackward, FaArrowCircleLeft, FaRegArrowAltCircleLeft, FaEyeDropper, FaRegEye, FaMehRollingEyes, FaBullseye, FaStreetView, FaEye, FaPerbyte, FaAngleUp, FaAdjust, FaMizuni, FaCreativeCommonsZero, FaCreativeCommons, FaAward, FaStethoscope, FaListOl, FaDAndD, FaDailymotion, FaGasPump, FaDesktop, FaFileMedical, FaBookMedical, FaCalendar, FaCalendarDay, FaCalendarAlt, FaTransgenderAlt, FaBirthdayCake, FaCalendarCheck, FaPhoenixFramework, FaPhoneAlt, FaPhoneSlash, FaMobile, FaMobileAlt, FaMarsStroke, FaWpforms, FaSync, FaUserPlus, FaTag, FaRegEdit, FaUserEdit} from 'react-icons/fa'
import ReactPaginate from "react-paginate";
import Modal from 'react-bootstrap/Modal';
import logo_side from "../../assets/signature/logo-side-detail.png"
import Logo_Signature from "../../assets/signature/signatureNewIcon.png"
import Logo_Batik from "../../assets/signature/logo-batik.png"
import "bulma/css/bulma.css";
import { useMutation } from "react-query";
import "../../index.css"
import Swal from "sweetalert2";
import swal from "sweetalert";
// Modal Role
import ModalAddMedis from "./ModalAdmin/ModalAdd"
import ModalUpdateMedis from "./ModalAdmin/ModalUpdate"
import { ScaleLoader } from "react-spinners";
import LoaderHome from "../Loader/LoaderHome"
import axios from "axios";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import {useRef} from 'react';

export default function Login() {
  // let navigate = useNavigate();
  // useEffect(() => {
  //   if (localStorage.getItem("token") == null || undefined) {
  //       navigate("/");
  //     }
  // }, []);
  document.title = "SDC Apps";
  const navigate = useNavigate()
  const [getData, setGetData] = useState([]);
  const [getDataFee, setGetDataFee] = useState([]);
  const [pagination,setPagination] = useState([])
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState();
  const [ascending, setAscending] = useState(0);
  const [rows, setRows] = useState(1);
  const [keyword, setKeyword] = useState("");
  const [query, setQuery] = useState("");
  const [msg, setMsg] = useState("");
  const token = localStorage.getItem("token");
  const [idDelete, setIdDelete] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [show, setShow] = useState(false);
  const [search,setSearch] = useState("")
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [dataMap, setDataMap] = useState("");
  const [dataSearch, setDataSearch] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const style = { position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
  // Responsive to mobile or dekstop
  const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1224px)'})
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 980px)'})
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)'})
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })
  // modal role add 
  const [id, setId] = useState();
  const [nameUpdate, setNameUpdate] = useState();
  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const [formatInterger, setFormatInterger] = useState(false);

  const toggleFormat = () => {
    // Mengganti state format
    setFormatInterger(true);
  };


  function formatToRupiah(angka) {
    const formatter = new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
    });
  
    // Format angka ke format mata uang Rupiah
    const formattedString = formatter.format(angka);
  
    // Menghilangkan simbol "RP" (simbol mata uang) dari hasil format
    const rupiahWithoutSymbol = formattedString.replace('Rp', '');
  
    return rupiahWithoutSymbol.trim(); // Menghilangkan spasi yang mungkin ada
  }

  const [form, setForm] = useState({
    month: "",
    year: ""
  });

  const [form2, setForm2] = useState({
    month: "",
    year: ""
  });

  let fetchParams = {
    headers : {"Authorization" : `${token}`,"Content-Type" : "application/json"}
  };
  // console.log(form)

  const GetResponseDataFee = async () => {
    try {
      // e.preventDefault();
      // setLoading(true)
      const response = await API.get(`transaction-service/fees?page=${page}&limit=${limit}&ascending=${ascending}&search=${keyword}`,fetchParams)

      // Checking process
      if (response?.status === 200) {
        setGetDataFee(response.data.data)
        // setPage(response.data.pagination.current_page);
        // setPages(response.data.pagination.total_pages);
        // setRows(response.data.pagination.total);
        // setLoading(false)
      }
    } catch (error) {
      // setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseData = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.post(`transaction-service/finances`, {
        monthYear: (new Date().getMonth() + 1).toString()-new Date().getFullYear().toString()
      },fetchParams)

      // Checking process
      if (response?.status === 200) {
        setGetData(response.data.data)
        // setPage(response.data.pagination.current_page);
        // setPages(response.data.pagination.total_pages);
        // setRows(response.data.pagination.total);
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const GetResponseData2 = async () => {
    try {
      // e.preventDefault();
      setLoading(true)
      const response = await API.post(`transaction-service/finances`, {
        monthYear: `${form2?.year}-${form2?.month}`
      },fetchParams)

      // Checking process
      if (response?.status === 200) {
        setGetData(response.data.data)
        // setPage(response.data.pagination.current_page);
        // setPages(response.data.pagination.total_pages);
        // setRows(response.data.pagination.total);
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      swal({
        title: 'Failed',
        text: `${error.response.data.message}`,
        icon: 'error',
        timer: 3000,
        buttons: false
      });
    }
  }

  const handleChange = (e) => {
    setForm2({
      ...form2,
      [e.target.name]: e.target.value,
    });
  };
  
  useEffect(() => {
    setForm({
      ...form, 
      month: (new Date().getMonth() + 1).toString(), // getMonth() dimulai dari 0, jadi tambahkan 1
      year: new Date().getFullYear().toString()
    });
  }, []);

  useEffect(() => {
    setForm2({
      ...form2, 
      month: (new Date().getMonth() + 1).toString(), // getMonth() dimulai dari 0, jadi tambahkan 1
      year: new Date().getFullYear().toString()
    });
  }, []);

  useEffect(() => {
    if (form?.month !== "" && form?.year !== "") {
      GetResponseData();
      GetResponseDataFee();
    }
  }, [form])


  const changePage = ({ selected }) => {
    setPage(selected+1);
    if (selected === 10) {
      setMsg(
        ""
      );
    } else {
      setMsg("");
    }
  };
 
  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setMsg("");
    setKeyword(query);
  };

  const buttonRefresh = () => {
    window.location.reload();
  }
  
  const viewModalAdd = () => {
    setModalAdd(true)
  }

  const viewModalUpdate = (id, name) => {
    setModalUpdate(true)
    setId(id)
    setNameUpdate(name)
  }

  const tahunSaatIni = new Date().getFullYear();
  // Membuat array variabel dengan 10 tahun terakhir
  const panjangTahun = 10;
  const arrayTahun = Array.from({ length: panjangTahun }, (_, index) => tahunSaatIni - index);
  
  return (
    <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
      {modalAdd && <ModalAddMedis GetResponseData={GetResponseData} show={modalAdd} onHide={() => setModalAdd(false)} />}
      {modalUpdate && <ModalUpdateMedis GetResponseData={GetResponseData} nameUpdate={nameUpdate} id={id} show={modalUpdate} onHide={() => setModalUpdate(false)} />}
      {loading && <LoaderHome />}

      {isTabletOrMobile? 
        <div style={{ paddingLeft: "0px", width: "100%", borderBottom: "5px solid #EEEEEE", display: "", padding: "0px 0px 10px 0px" }}>
        <Col xl="6" style={{fontSize:"16px",display:"flex", justifyContent:"center", alignItems:"center", padding:"7px", color:"#001F8B", backgroundColor:"#E9EFFF"}}>
          <FaAddressBook style={{marginRight:"5px"}}/>List User Fee
        </Col>
        <Col className="mt-2" xl="6" style={{ display: "flex", justifyContent:"end", paddingRight:"5px" }}>
          <div onClick={viewModalAdd} style={{display:"flex",alignItems:"center",marginRight:"5px",backgroundColor:"#3D64FF",color:"white",padding:"0px 12px", borderRadius:"3px", cursor:"pointer", fontSize:"12px", cursor:"pointer"}}>
            <FaPlus/>
          </div>
            <div onClick={buttonRefresh} style={{ height: "100%", marginRight: "5px", paddingTop: "0px", backgroundColor: "white", padding: "10px 10px", borderRadius: "2px", cursor: "pointer", border: "1px solid #DEDEDE" }}>
              <FaSync style={{ fontSize: "15px", marginRight: "0px", marginTop: "0px", display: "flex", alignItems: "center", height:"100%", color:"#3D64FF" }} />
            </div>
            <form onSubmit={searchData} style={{display:"flex", paddingRight:"0px"}}>
              <div style={{marginRight:"5px",borderRadius:"3px"}}>
                <input value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="focused"
                style={{backgroundColor:"#E9E9E9", border:"none",height:"100%"}}
                type="text"
                placeholder=""
                />
              </div>
              <button type="submit"  style={{ border: "none", backgroundColor: "#3D64FF", color: "white", display: "flex", borderRadius:"2px", fontWeight:"600", fontSize:"12px",alignItems:"center", padding:"0px 10px" }}>
                Search
              </button>
            </form>
        </Col>
        </div>
        :
        <div style={{ paddingLeft: "0px", width: "100%", borderBottom: "5px solid #EEEEEE", display: "flex", padding: "10px 0px" }}>
          <div style={{flex:"70%",fontSize:"16px",display:"flex", alignItems:"center", paddingLeft:"10px", color:"#001F8B"}}>
            <FaAddressBook style={{marginRight:"5px"}}/>List User Fee
          </div>
          <div style={{ flex: "30%", display: "flex", justifyContent: "end" }}>
            <DownloadTableExcel
              filename="users table"
              sheet="users"
              currentTableRef={tableRef.current}
              style={{border:"1px solid yellow"}}
              >
              <button onMouseEnter={()=> setFormatInterger(true)} onMouseLeave={()=> setFormatInterger(false)} style={{marginRight:"5px", height:"100%", padding:"0px 10px", borderRadius:"3px", border:"1px solid #D1D1D1"}}>Excel</button>
            </DownloadTableExcel>
            
            {/* <div className="mr-2" onClick={GetResponseData2} style={{ border: "1px solid #CECECE", backgroundColor: "", color: "", display: "flex", borderRadius:"3px", fontWeight:"600", fontSize:"12px",alignItems:"center", padding:"0px 20px", cursor:"pointer" }}>
              Pdf
            </div>
            <div className="mr-2" onClick={GetResponseData2} style={{ border: "1px solid #CECECE", backgroundColor: "", color: "", display: "flex", borderRadius:"3px", fontWeight:"600", fontSize:"12px",alignItems:"center", padding:"0px 20px", cursor:"pointer" }}>
              Excel
            </div> */}
            {/* <div onClick={viewModalAdd} style={{display:"flex",alignItems:"center",marginRight:"5px",backgroundColor:"#3D64FF",color:"white",padding:"0px 10px", borderRadius:"3px", cursor:"pointer", fontSize:"12px", cursor:"pointer"}}>
              <FaPlus/>
            </div>
            <div onClick={buttonRefresh} style={{ height: "100%", marginRight: "5px", paddingTop: "0px", backgroundColor: "white", padding: "0px 10px", border: "1px solid #DEDEDE", borderRadius: "3px", cursor: "pointer" }}>
              <FaSync style={{ fontSize: "15px", marginRight: "0px", marginTop: "0px", display: "flex", alignItems: "center", height:"100%", color:"#3D64FF" }} />
            </div> */}
            <select className="form-select mr-1" aria-label="Default select example" value={form2?.month}   name="month" onChange={handleChange} style={{ textAlign:"center", cursor:"pointer", fontSize:"13px"}}>
              <option value="" hidden>Month</option>
              <option value="01" style={{ textAlign:"center"}}>Januari</option>
              <option value="02" style={{textAlign:"center"}}>Februari</option>w
              <option value="03" style={{textAlign:"center"}}>Maret</option>
              <option value="04" style={{textAlign:"center"}}>April</option>
              <option value="05" style={{textAlign:"center"}}>Mei</option>
              <option value="06" style={{textAlign:"center"}}>Juni</option>
              <option value="07" style={{textAlign:"center"}}>Juli</option>
              <option value="08" style={{textAlign:"center"}}>Agustus</option>
              <option value="09" style={{textAlign:"center"}}>September</option>
              <option value="10" style={{textAlign:"center"}}>Oktober</option>
              <option value="11" style={{textAlign:"center"}}>November</option>
              <option value="12" style={{textAlign:"center"}}>Desember</option>    
            </select>
            <select className="form-select mr-1" aria-label="Default select example" value={form2?.year} name="year" onChange={handleChange} style={{ textAlign:"center", cursor:"pointer", fontSize:"13px"}}>
              <option value="" hidden>Year</option>
              {arrayTahun.map((tahun, index) => (
                <option key={index} value={tahun}>{tahun}</option>
              ))}
            </select>
          <form  style={{display:"flex", paddingRight:"10px"}}>
          {/* <div style={{marginRight:"5px",borderRadius:"3px"}}>
            <input value={query}
              onChange={(e) => setQuery(e.target.value)}
              className="focused"
              style={{backgroundColor:"#E9E9E9", border:"none",height:"5vh"}}
              type="text"
              placeholder=""
            />
          </div> */}
            <div onClick={GetResponseData2}  style={{ border: "none", backgroundColor: "#3D64FF", color: "white", display: "flex", borderRadius:"3px", fontWeight:"600", fontSize:"12px",alignItems:"center", padding:"0px 20px", cursor:"pointer" }}>
              Filter
            </div>
          </form>
          </div>
        </div>  
      }
 
  <Col xl='12' sm='12'> 
  <div>
    <div style={{display:"block", height:"100%", overflowY:"auto",overflowX:"auto"}}>
      <div >
      <table className="table is-bordered" ref={tableRef}>
          <thead>
            <tr style={{ backgroundColor: isTabletOrMobile ? "white" : "#E9EFFF" }}>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>No</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none", position: "sticky", left: 0, zIndex: 1, background: "#E9EFFF" }}>
                No. Inv
              </th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>TANGGAL</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>NAMA PASIEN</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>NAMA DOKTER</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>TINDAKAN</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>OMSET</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>DISCOUNT</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>JUMLAH</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>BY ADM BANK 1%</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>MODAL</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>BY OPR & MKT 20%</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>FEE DOKTER 10%</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>FEE DOKTER 20%</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>FEE DOKTER 40%</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>FEE DOKTER 45%</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>FEE DOKTER 50%</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>FEE DOKTER 55%</th>
              <th style={{ fontSize: "12px", textAlign: "center", color: "#525252", border: "none" }}>JUMLAH</th>
            </tr>
          </thead>
          <tbody>
          {getData.map((user, index) => (
          <React.Fragment key={index}>
            {/* Informasi pasien */}
            <tr style={{ fontSize: "11px", textAlign: "center" }}>
              <td style={{ lineHeight: "2" }}>{page === 1 ? index + 1 : page === 2 ? index + 11 : index + (page * 10)}</td>
              <td style={{ lineHeight: "2", wordWrap: "break-word"}}>{user.code}</td>
              <td style={{ lineHeight: "2" }}>{user.date}</td>
              <td style={{ lineHeight: "2" }}>{user.patient_name}</td>
              {/* Handling the first item in medical_treatment_invoices separately */}
              {user.medical_invoice.medical_treatment_invoices.length > 0 && (
                <>
                  <td style={{ lineHeight: "2" }}>{user.medical_invoice.medical_treatment_invoices[0].medical_record.treatment_plan_detail.doctor_name}</td>
                  {getDataFee.map((user, index) => (
                   <> 
                    <td style={{ lineHeight: "2" }}>{user.name}</td>
                      <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? user.price : formatToRupiah(user.price)}</td>  
                      <td style={{ lineHeight: "2" }}></td>
                      <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? user.price : formatToRupiah(user.price)}</td> 
                      <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? user.price * 0.01 : formatToRupiah(user.price * 0.01)}</td>  
                      <td style={{ lineHeight: "2" }}></td>  
                      <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? user.price * 0.2 - ((user.price * 0.01) * 0.2) : formatToRupiah(user.price * 0.2 - ((user.price * 0.01) * 0.2))}</td>  
                      <td style={{ lineHeight: "2" }}></td>
                      <td style={{ lineHeight: "2" }}></td>
                      <td style={{ lineHeight: "2" }}></td>
                      <td style={{ lineHeight: "2" }}></td>
                      <td style={{ lineHeight: "2" }}></td>
                      <td style={{ lineHeight: "2" }}></td>
                      <td style={{ lineHeight: "2" }}></td>
                    </>  
                  ))}
                </>
              )}

              {/* Buttons */}
              {/* <td style={{ lineHeight: "2" }}>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center" }}>
                  <button onClick={() => viewModalUpdate(user?.id, user?.name)} style={{ fontSize: "13px", color: "white", backgroundColor: "#ff9933", padding: "5px 5px", borderRadius: "3px", cursor: "pointer", border: "none", display: "flex", marginRight: "3px" }}>
                    <FaEdit />
                  </button>
                  <button onClick={() => { deleteById(user?.id) }} style={{ fontSize: "12px", color: "white", backgroundColor: "#B60000", padding: "5px 5px", borderRadius: "3px", cursor: "pointer", border: "none", display: "flex" }}>
                    <FaTrash />
                  </button>
                </div>
              </td> */}
            </tr>
            {/* Handling other items in medical_treatment_invoices */}
            {(user.medical_invoice.medical_treatment_invoices.map((invoice, invoiceIndex) => (
                <tr key={invoiceIndex} style={{ fontSize: "11px", textAlign: "center" }}>
                  <td style={{ lineHeight: "2" }}></td>
                  <td style={{ lineHeight: "2" }}></td>
                  <td style={{ lineHeight: "2" }}></td>
                  <td style={{ lineHeight: "2" }}></td>
                  <td style={{ lineHeight: "2" }}>{invoice.medical_record.treatment_plan_detail.doctor_name}</td>
                  <td style={{ lineHeight: "2" }}>{invoice.medical_record.treatment_plan_detail.treatment_data.name}</td>
                  <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.price : formatToRupiah(invoice.price)}</td>
                  <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.discount === null || invoice.discount === "null" || invoice.discount === undefined || invoice.discount === "undefined" || invoice.discount === 0 || invoice.discount === "0" ? "" : invoice.discount : invoice.discount === null || invoice.discount === "null" || invoice.discount === undefined || invoice.discount === "undefined" || invoice.discount === 0 || invoice.discount === "0" ? "" : formatToRupiah(invoice.discount)}</td>
                  <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.price_after_discount === null || invoice.price_after_discount === "null" || invoice.price_after_discount === undefined || invoice.price_after_discount === "undefined" || invoice.price_after_discount === 0 || invoice.price_after_discount === "0" ? invoice.price : invoice.price_after_discount : invoice.price_after_discount === null || invoice.price_after_discount === "null" || invoice.price_after_discount === undefined || invoice.price_after_discount === "undefined" || invoice.price_after_discount === 0 || invoice.price_after_discount === "0" ? formatToRupiah(invoice.price) : formatToRupiah(invoice.price_after_discount)}</td>  
                  <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.bankFee : formatToRupiah(invoice.bankFee)}</td>
                  <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? 
                    invoice.medical_record.treatment_plan_detail.treatment_data.cost_lab === null ? "" : invoice.medical_record.treatment_plan_detail.treatment_data.cost_lab : 
                    invoice.medical_record.treatment_plan_detail.treatment_data.cost_lab === null ? "" : formatToRupiah(invoice.medical_record.treatment_plan_detail.treatment_data.cost_lab)}
                  </td>
                  <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.fundFee : formatToRupiah(invoice.fundFee)}</td>
                  
                  {user.doctor_fee === 10 && (
                  <>
                    <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.totalFeeCount : formatToRupiah(invoice.totalFeeCount)}</td> 
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                  </>  
                  )}

                  {/* 
                  {invoice.medical_record.treatment_plan_detail.treatment_data.fee_persentage === 20 ?  
                  user.doctor_fee === 20? : && (
                  <>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.totalFeeCount : formatToRupiah(invoice.totalFeeCount)}</td> 
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                  </>
                  )} */}

                  {
                    invoice.medical_record.treatment_plan_detail.treatment_data.fee_persentage === 20
                    ? invoice.medical_record.treatment_plan_detail.treatment_data.fee_percentage
                    : (invoice.medical_record.treatment_plan_detail.treatment_data.fee_percentage === null && user.doctor_fee === 20) && (
                      <>
                        <td style={{ lineHeight: "2" }}></td>
                        <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true ? invoice.totalFeeCount : formatToRupiah(invoice.totalFeeCount)}</td>
                        <td style={{ lineHeight: "2" }}></td>
                        <td style={{ lineHeight: "2" }}></td>
                        <td style={{ lineHeight: "2" }}></td>
                        <td style={{ lineHeight: "2" }}></td>
                      </>
                    )
                  }

                  {
                    invoice.medical_record.treatment_plan_detail.treatment_data.fee_persentage === 40
                    ? invoice.medical_record.treatment_plan_detail.treatment_data.fee_percentage
                    : (invoice.medical_record.treatment_plan_detail.treatment_data.fee_percentage === null && user.doctor_fee === 40) && (
                      <>
                        <td style={{ lineHeight: "2" }}></td>
                        <td style={{ lineHeight: "2" }}></td>
                        <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.totalFeeCount : formatToRupiah(invoice.totalFeeCount)}</td> 
                        <td style={{ lineHeight: "2" }}></td>
                        <td style={{ lineHeight: "2" }}></td>
                        <td style={{ lineHeight: "2" }}></td>
                      </>
                    )
                  }

                  {user.doctor_fee === 45 && (
                  <>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.totalFeeCount : formatToRupiah(invoice.totalFeeCount)}</td> 
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                  </>
                  )}

                  {user.doctor_fee === 50 && (
                  <>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.totalFeeCount : formatToRupiah(invoice.totalFeeCount)}</td> 
                    <td style={{ lineHeight: "2" }}></td>
                  </>
                  )}

                  {user.doctor_fee === 55 && (
                  <>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}></td>
                    <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.totalFeeCount : formatToRupiah(invoice.totalFeeCount)}</td> 
                  </>
                  )}

                  <td style={{ lineHeight: "2" }}>{formatInterger === "true" || formatInterger === true? invoice.totalFeeCount : formatToRupiah(invoice.totalFeeCount)}</td> 
                </tr>
              ))
            )}
              </React.Fragment>
            ))}
                    
          </tbody>
      </table>
            
      </div>
        </div>
        </div>
        {/* <div style={{ display: "flex", padding:"10px"}}>
          <div>
            <div style={{fontSize:"12px"}}>
              Total Rows: {rows} 
            </div>
            <div style={{fontSize:"12px"}}>
              Page: {rows ? page : 0} of {pages}
            </div>
            <p className="has-text-centered has-text-danger">{msg}</p>
          </div> 
            <div style={{flex:"50%", display:"flex", justifyContent:"end"}}>
              <nav
                style={{fontSize:"12px"}}
                className="pagination is-centered"
                key={rows}
                role="navigation"
                aria-label="pagination"
                >
                <ReactPaginate
                  previousLabel={"<"}
                  nextLabel={">"}
                  pageCount={Math.min(10, pages)}
                  onPageChange={changePage}
                  containerClassName={"pagination-list"}
                  pageLinkClassName={"pagination-link"}
                  previousLinkClassName={"pagination-previous"}
                  nextLinkClassName={"pagination-next"}
                  activeLinkClassName={"pagination-link is-current"}
                  disabledLinkClassName={"pagination-link is-disabled"}
                />
                </nav>
              </div>
           </div>    
        */}
  </Col>
</div>
  );
}
